import type { RouteRecordRaw } from 'vue-router';
import type { ModuleDefinition } from './defineModule.ts';

export function loadModuleRoutes(): RouteRecordRaw[] {
    const modules = import.meta.glob('@/modules/**/index.js', {
        eager: true,
    });

    const routes = Object.values(modules).flatMap((mod: any) => {
        const def = mod.default as ModuleDefinition;
        return def.routes;
    });

    // Load dev routes only in development
    if (import.meta.env.DEV) {
        const devModules = import.meta.glob('@/dev/index.js', {
            eager: true,
        });

        const devRoutes = Object.values(devModules).flatMap((mod: any) => {
            const def = mod.default as ModuleDefinition;
            return def.routes;
        });

        routes.push(...devRoutes);
    }

    return routes;
}
